import { Navigate, Outlet } from "react-router";
import { useSession } from "@/lib/auth-client";

export function ProtectedRoute() {
	const { data: session, isPending } = useSession();

	if (isPending) {
		return (
			<div className="min-h-screen flex items-center justify-center text-[12px] text-[var(--color-text-dim)]">
				loading…
			</div>
		);
	}

	if (!session?.user) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
}
